import { Grid, Typography, Button } from "@mui/material";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import IDayliPlanAppointment from "../interface/iDayliPlanAppointment";

const Uploads = ({
  appointment,
  setShowFileDialog,
}: {
  appointment: IDayliPlanAppointment;
  setShowFileDialog: (showFileDialog: any) => void;
}): React.JSX.Element => (
  <Grid
    item
    xs={6}
    sm={6}
    md={6}
    lg={3}
    sx={{
      mb: 2,
    }}
  >
    <Typography
      sx={{
        fontWeight: "bold",
      }}
      variant="caption"
      component="p"
    >
      Uploads
    </Typography>

    {appointment.files.meta.total === 0 ? (
      <Typography variant="body1" component="p">
        Keine Dateien vorhanden
      </Typography>
    ) : (
      <Button
        sx={{
          mr: 2,
        }}
        size="small"
        endIcon={<FileUploadOutlinedIcon />}
        variant="outlined"
        color="primary"
        onClick={() =>
          setShowFileDialog({
            open: true,
            participant: appointment,
          })
        }
      >
        Unterlagen
      </Button>
    )}
  </Grid>
);

export default Uploads;
